import { Component, OnInit, OnDestroy } from '@angular/core';
import { Platform } from '@ionic/angular';

import { CsiteSupplier, QuproList, QuproServiceError, CsitesFilterSupplier } from '@arpada/arp-lib-common-qupro';

import { PortalProveedorService, UiService, GeneralPopulateService } from '../../services/api.services';
import { Subscription } from 'rxjs';
import { CsiteData } from './csite.data';
import { DatatableMessage } from '../../models/api.models';
import { ActionsSharedData } from '../shared/actions-header/actions.shared.data';

@Component({
  selector: 'app-csites',
  templateUrl: './csites.component.html',
  styleUrls: ['./csites.component.scss'],
})

export class CsitesComponent implements OnInit, OnDestroy {
  csites: CsiteSupplier[] = [];
  csitesFilter: CsitesFilterSupplier = new CsitesFilterSupplier();

  showListButton =  false;
  showCardListButton = true;
  showList = true;
  showCardList = false;

  totalCount = '-';
  totalCountNumber = -1;

  csiteData: CsiteData = new CsiteData();

  sharedData: ActionsSharedData = new ActionsSharedData();

  private selectOperatorSubscription: Subscription;
  private modoVistaSubscription: Subscription;

  constructor(private portalProveedorService: PortalProveedorService,
              private uiService: UiService,
              public platform: Platform,
              private generalPopulateService: GeneralPopulateService) {
    this.initFilter();
    this.initCsiteData();
  }

  ngOnDestroy(): void {
    if (this.selectOperatorSubscription) {
      this.selectOperatorSubscription.unsubscribe();
    }

    if (this.modoVistaSubscription) {
      this.modoVistaSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    const modoVista = localStorage.getItem('modoVista');
    this.showModoVista(modoVista);
    this.getCsites();
    this.selectOperatorSubscription = this.portalProveedorService.selectOperatorEvent.subscribe(operatorId => {
      this.csitesFilter.operator_num = operatorId;
      this.getCsites();
    });
    this.modoVistaSubscription = this.portalProveedorService.modoVistaEvent.subscribe(modoVistaReceived => {
      this.showModoVista(modoVistaReceived);
    });
  }

  onListPressed(event: Event) {
    this.showListButton = false;
    this.showCardListButton = true;
    this.showList = true;
    this.showCardList = false;

  }

  onCardListPressed(event: Event) {
    this.showListButton = true;
    this.showCardListButton = false;
    this.showList = false;
    this.showCardList = true;
  }

  private getCsites() {
    this.csiteData.msg.emptyMessage = this.generalPopulateService.changeMms(true);
    this.portalProveedorService.getCsitesOfSupplier(this.csitesFilter).subscribe((csitesList: QuproList<CsiteSupplier>) => {
      this.csiteData.csites = csitesList.elements;
      this.csiteData.msg.emptyMessage = this.generalPopulateService.changeMms(false);
    }, (error: QuproServiceError) => {
      this.showErrorToast(error.message);
    });
  }

  private showModoVista(modoVista: string) {
    if (modoVista === 'cards') {
      this.onCardListPressed(null);
    }
    if (modoVista === 'escritorio') {
      this.onListPressed(null);
    }
  }

  private initCsiteData() {
    this.csiteData.csites = [];
    this.csiteData.msg = new DatatableMessage();
    this.csiteData.msg.emptyMessage = '';
  }

  private initFilter() {
    const newFilter: CsitesFilterSupplier = new CsitesFilterSupplier();
    const operatorIdSelected = this.portalProveedorService.getOperatorSel();
    if (operatorIdSelected) {
      newFilter.operator_num = operatorIdSelected;
    }
    Object.assign(this.csitesFilter, newFilter);
  }

  private showErrorToast(message: string) {
    this.uiService.showMiddleToastWithButton(message, 2000000);
  }

}
